import { Component, Input } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { BaseControlComponent } from './base-control.component';

@Component({
    selector: 'app-text-area-control',
    template: `
    <div class="app-pr1 app-pb1 txtareadetail">
      <mat-form-field [hintLabel]="hintLabel | translation: translationRequest" [formGroup]="formGroup">
        <mat-label>{{ label | translation: translationRequest }}</mat-label>
        <textarea
          matInput
          #input
          [attr.maxlength]="maxLength"
          [placeholder]="placeHolder"
          [formControlName]="formControlName"
          [rows]="rows"
          autocomplete="off"
          [attr.disabled]="disabled ? 'disabled' : null"
          [aria-describedby]="ariaDescribedBy"
          >
          ></textarea
          >
          @if (maxLength > 0) {
            <mat-hint align="end"
              >{{ input.value?.length || 0 }}/{{ maxLength }}</mat-hint
              >
            }
            @if (formControl.invalid) {
              <mat-error class="errormsg">{{
                errorMessage | translation: translationRequest
              }}</mat-error>
            }
          </mat-form-field>
        </div>
    `,
    styles: [
        `
      .txtareadetail {
        color: #67707a !important;
        border-color: #67707a !important;
      }
      /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
      .txtareadetail::ng-deep .mat-form-field-outline {
        color: #67707a;
      }

      .txtareadetail:focus {
        color: #171c20 !important;
        border: #007dbc !important;
      }

      .txtareadetail:hover {
        color: #67707a !important;
        border: #3f464d !important;
      }
      /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version. */
      .txtareadetail:focus::ng-deep .mat-form-field-outline {
        color: #007dbc;
      }
    `,
    ],
    standalone: false
})
export class TextAreaControlComponent extends BaseControlComponent {
  @Input()
  maxLength: number;

  @Input()
  rows: number = 3;

  @Input()
  disabled = false;

  @Input()
  ariaDescribedBy: string;

  translationRequest = new TranslationRequest({
		language: sessionStorage.getItem('languagepreference'),
		key: null,
		contNum: 0,
		tableName: null,
		primaryKey: null,
		primaryValue: null,
		lob: null,
		group: 'Shared',
		subGroup: 'Shared',
	  });

  getElementByXpath(path: string) {
    return document.evaluate(
      path,
      document,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    ).singleNodeValue;
  }
}
